<!--
 * @Author: cryi.liu
 * @Date: 2020-05-13 14:33:55
 * @LastEditTime: 2020-05-14 09:29:12
 * @Description: 正在处理提示组件
 -->
<template>
  <div id="processing" :class="show ? 'show' : ''">
    <div class="tip">{{ text }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Processing',
  computed: {
    ...mapGetters({
      show: 'pageStore/processingShowState',
      text: 'pageStore/processingShowText',
    }),
  },
};
</script>

<style lang="less" scoped>
#processing {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3100;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .12);

  &.show {
    display: block;
  }

  > .tip {
    position: absolute;
    top: 0;
    right: 0;
    padding: 6px 20px;
    background-color: #000;
    border: 3px solid #ddd;
    color: #fff;
    font-weight: bold;
  }
}
</style>
